// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"6536a2c5","462":"5c915763","518":"6a466aba","542":"5c915763","873":"41c09c4c","977":"a6c3f736"}[chunkId] + ".chunk.css";
};